import { fromJSON, toJSON } from 'app/infrastructure/platform/json';

/**
 *  Return a default fallback value when possible
 */
export function typedValue(value: any) {
  let result: any = undefined;

  if (!value) { //no point in converting 0, false, undefined, null
    return value;
  }

  result = fromJSON(toJSON(value));

  if (JSON.stringify(result) === '{}') {
    return undefined;
  }

  return result;
}
